import { DisclaimerComponent } from "@rainbow-me/rainbowkit";
import React from "react";

export const Disclaimer: DisclaimerComponent = ({ Text, Link }) => (
  <Text>
    By connecting a wallet, you agree to the
    <br />
    <Link href="https://bebop.xyz/privacy.pdf">Privacy Policy</Link> and{" "}
    <Link href="https://bebop.xyz/terms.pdf">Terms of Use</Link>
  </Text>
);
